import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { ContextManager } from '../../context/manager';

const { Icon } = elements;

type Props = {
  isDisabled: boolean;
  contextSetting: string;
};

function MenuEditButton({ isDisabled, contextSetting }: Readonly<Props>) {
  const handleEditClick = () => {
    ContextManager.getInstance().setSettingAsRequiresEdit(contextSetting);
  };

  return (
    <button
      onClick={handleEditClick}
      tabIndex={-1}
      className={`menu-edit-button rounded h-10 w-10 border border-default px-2 ${
        isDisabled ? 'cursor-default text-inactive' : 'transition-colours hover:bg-brand-lightest'
      }`}
      disabled={isDisabled}
    >
      <Icon color={isDisabled ? 'inactive' : 'brand'} size="md">
        <Icon.icons.Edit />
      </Icon>
    </button>
  );
}

export { MenuEditButton };
